//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GoogleMaps from '../../components/general/GoogleMaps'
import emailjs from 'emailjs-com'

export default {
    metaInfo: {
        meta: [
            {charset: 'utf-8'},
            {
                name: 'viewport',
                content:
                    'width=device-width, initial-scale=1, user-scalable=no',
            },
        ],
    },
    data() {
        return {
            selectedCategory: null,
            categories: [
                'Todo / All',
                'Entradas / Starters',
                'Platillos / Main dishes',
                'Ceviches',
                'Bebidas / Drinks',
                'Acompañantes / Sides',
            ],
            selectedItemIndex: 0,
            name: '',
            orderNo: '',
            seamless: false,
            displayLoading: false,
            whatsappNumber: '64807710',
            selectedItem: {},
            paymentMethods: [
                {label: 'Yappy', value: 'Yappy'},
                {label: 'Efectivo', value: 'Efectivo'},
                {label: 'Tarjeta', value: 'Tarjeta'},
            ],
            pickupMethods: [
                {label: 'Delivery', value: 'Delivery'},
                {label: 'Retirar en local', value: 'Retirar en local'},
            ],
            selectedPaymentMethod: null,
            selectedPickupMethod: '',
            address: '',
            total: 0,
            location: [],
            markers: [],
            center: {},
            optionsDialog: false,
            stylesDialog: false,
            sideDialog: false,
            successDialog: false,
            cartDialog: false,
            cart: [],
            menu: [
                {
                    title: 'Almejas al ajillo',
                    subtitle: 'Clams in garlic sauce',
                    desc: '',
                    options: [{title: 'Regular', price: 0}],
                    styles: [],
                    sides: [],
                    sides: [],
                    pic: 'almejas.jpg',
                    price: 6,
                    type: 'starter',
                },
                {
                    title: 'Deditos de pescado',
                    subtitle: 'Fish fingers',
                    desc: '',
                    options: [{title: 'Regular', price: 0}],
                    styles: [],
                    sides: [],
                    pic: 'deditos_de_pescao.jpg',
                    price: 6,
                    type: 'starter',
                },
                {
                    title: 'Alitas',
                    subtitle: 'Buffalo wings',
                    desc: '',
                    options: [{title: 'Regular', price: 0}],
                    styles: [],
                    sides: [],
                    pic: 'alitas.jpeg',
                    price: 6,
                    type: 'starter',
                },
                {
                    title: 'Arañitas',
                    subtitle: 'Fried baby squid',
                    desc: '',
                    options: [{title: 'Regular', price: 0}],
                    styles: [],
                    sides: [],
                    pic: 'aranitas_2.jpeg',
                    price: 6,
                    type: 'starter',
                },
                {
                    title: 'Sopa de mariscos',
                    subtitle: 'Seafood mix soup',
                    desc: '',
                    options: [{title: 'Regular', price: 0}],
                    styles: [],
                    sides: [],
                    pic: 'sopa_de_mariscos.jpeg',
                    price: 8,
                    type: 'starter',
                },
                {
                    title: 'Pescado entero frito',
                    subtitle: 'Fried fish',
                    desc:
                        'Pescado entero frito chico, mediano o grande, con ensalada y acompañamiento de su eleccion.',
                    options: [
                        {
                            title: 'Chico',
                            price: 10,
                        },
                        {
                            title: 'Mediano',
                            price: 12,
                        },
                        {
                            title: 'Grande',
                            price: 15,
                        },
                    ],
                    styles: [
                        {title: 'Patacones', price: 0},
                        {title: 'Yuca al mojo', price: 0},
                        {title: 'Yuca frita', price: 0},
                        {title: 'Papas fritas', price: 0},
                        {title: 'Arroz', price: 0},
                    ],
                    sides: [],
                    pic: 'pescao_frito.jpg',
                    price: 0,
                    type: 'main',
                },
                {
                    title: 'Filete de pescado frito',
                    subtitle: 'Fried fish filet',
                    desc: 'Con ensalada y acompañamiento de su eleccion.',
                    options: [
                        {title: 'Patacones', price: 0},
                        {title: 'Yuca al mojo', price: 0},
                        {title: 'Yuca frita', price: 0},
                        {title: 'Papas fritas', price: 0},
                        {title: 'Arroz', price: 0},
                    ],
                    styles: [],
                    sides: [],
                    pic: 'filete_frito.jpg',
                    price: 8,
                    type: 'main',
                },
                {
                    title: 'Filete de pescado frito con salsa al ajillo',
                    subtitle: 'Fried fish filet with garlic sauce',
                    desc: 'Con ensalada y acompañamiento de su eleccion.',
                    options: [
                        {title: 'Patacones', price: 0},
                        {title: 'Yuca al mojo', price: 0},
                        {title: 'Yuca frita', price: 0},
                        {title: 'Papas fritas', price: 0},
                        {title: 'Arroz', price: 0},
                    ],
                    styles: [],
                    sides: [],
                    pic: 'filete_al_ajillo.jpg',
                    price: 9,
                    type: 'main',
                },
                {
                    title: 'Filete de pescado frito apanado',
                    subtitle: 'Breaded fried fish filet',
                    desc: 'Con ensalada y acompañamiento de su eleccion.',
                    options: [
                        {title: 'Patacones', price: 0},
                        {title: 'Yuca al mojo', price: 0},
                        {title: 'Yuca frita', price: 0},
                        {title: 'Papas fritas', price: 0},
                        {title: 'Arroz', price: 0},
                    ],
                    styles: [],
                    sides: [],
                    pic: 'filete_apanado.jpg',
                    price: 9,
                    type: 'main',
                },
                {
                    title: 'Especial de la casa, Pescado a lo macho',
                    subtitle: '',
                    desc:
                        'Pescado entero frito con mixto de marisco, camarones, almejas y langosta, con ensalada y acompañamiento de su eleccion. / Specialty of the house, fried fish with seafood mix, shrimps, clams and lobster, with salad and side of your choice.',
                    options: [
                        {title: 'Patacones', price: 0},
                        {title: 'Yuca al mojo', price: 0},
                        {title: 'Yuca frita', price: 0},
                        {title: 'Papas fritas', price: 0},
                        {title: 'Arroz', price: 0},
                    ],
                    styles: [],
                    sides: [],
                    pic: 'especial_a_lo_macho.jpg',
                    price: 35,
                    type: 'main',
                },
                {
                    title: 'Pescado frito con almejas',
                    subtitle: 'Fried fish with clams',
                    desc:
                        'Pescado frito con almejas chico, mediano o grande, con ensalada y acompañamiento de su eleccion.',
                    options: [
                        {
                            title: 'Chico',
                            price: 14,
                        },
                        {
                            title: 'Mediano',
                            price: 16,
                        },
                        {
                            title: 'Grande',
                            price: 19,
                        },
                    ],
                    styles: [
                        {title: 'Patacones', price: 0},
                        {title: 'Yuca al mojo', price: 0},
                        {title: 'Yuca frita', price: 0},
                        {title: 'Papas fritas', price: 0},
                        {title: 'Arroz', price: 0},
                    ],
                    sides: [],
                    pic: 'pescao_con_almeja.jpg',
                    price: 0,
                    type: 'main',
                },
                {
                    title: 'Pescado frito con camarones',
                    subtitle: 'Fried fish with shrimps',
                    desc:
                        'Pescado frito con camarones chico, mediano o grande, con ensalada y acompañamiento de su eleccion.',
                    options: [
                        {
                            title: 'Chico',
                            price: 14,
                        },
                        {
                            title: 'Mediano',
                            price: 16,
                        },
                        {
                            title: 'Grande',
                            price: 19,
                        },
                    ],
                    styles: [
                        {title: 'Patacones', price: 0},
                        {title: 'Yuca al mojo', price: 0},
                        {title: 'Yuca frita', price: 0},
                        {title: 'Papas fritas', price: 0},
                        {title: 'Arroz', price: 0},
                    ],
                    sides: [],
                    pic: 'pescao_con_camarones.jpg',
                    price: 0,
                    type: 'main',
                },
                {
                    title: 'Pescado frito con mixto de mariscos',
                    subtitle: 'Fried fish with seafood mix',
                    desc:
                        'Pescado frito con mixto de mariscos chico, mediano o grande, con ensalada y acompañamiento de su eleccion.',
                    options: [
                        {
                            title: 'Chico',
                            price: 14,
                        },
                        {
                            title: 'Mediano',
                            price: 16,
                        },
                        {
                            title: 'Grande',
                            price: 19,
                        },
                    ],
                    styles: [
                        {title: 'Patacones', price: 0},
                        {title: 'Yuca al mojo', price: 0},
                        {title: 'Yuca frita', price: 0},
                        {title: 'Papas fritas', price: 0},
                        {title: 'Arroz', price: 0},
                    ],
                    sides: [],
                    pic: 'pescao_con_mixto_de_mariscos.jpg',
                    price: 0,
                    type: 'main',
                },
                {
                    title: 'Filete de pescado frito con almejas',
                    subtitle: 'Fried fish filet with clams',
                    desc: 'Con ensalada y acompañamiento de su eleccion.',
                    options: [
                        {title: 'Patacones', price: 0},
                        {title: 'Yuca al mojo', price: 0},
                        {title: 'Yuca frita', price: 0},
                        {title: 'Papas fritas', price: 0},
                        {title: 'Arroz', price: 0},
                    ],
                    styles: [],
                    sides: [],
                    pic: 'filete_con_almejas.jpg',
                    price: 12,
                    type: 'main',
                },
                {
                    title: 'Filete de pescado frito con camarones',
                    subtitle: 'Fried fish filet with shrimps',
                    desc: 'Con ensalada y acompañamiento de su eleccion.',
                    options: [
                        {title: 'Patacones', price: 0},
                        {title: 'Yuca al mojo', price: 0},
                        {title: 'Yuca frita', price: 0},
                        {title: 'Papas fritas', price: 0},
                        {title: 'Arroz', price: 0},
                    ],
                    styles: [],
                    sides: [],
                    pic: 'filete_con_camarones.jpg',
                    price: 12,
                    type: 'main',
                },
                {
                    title: 'Filete de pescado frito con mixto de mariscos',
                    subtitle: 'Fried fish filet with seafood mix',
                    desc: 'Con ensalada y acompañamiento de su eleccion.',
                    options: [
                        {title: 'Patacones', price: 0},
                        {title: 'Yuca al mojo', price: 0},
                        {title: 'Yuca frita', price: 0},
                        {title: 'Papas fritas', price: 0},
                        {title: 'Arroz', price: 0},
                    ],
                    styles: [],
                    sides: [],
                    pic: 'filete_con_mixto.jpg',
                    price: 12,
                    type: 'main',
                },
                {
                    title: 'Picada mixta',
                    subtitle: 'Mixed platter',
                    desc:
                        'Picada mixta chicha o grande con ensalada y acompañamiento de su eleccion.',
                    options: [
                        {
                            title: 'Chica',
                            price: 20,
                        },
                        {
                            title: 'Grande',
                            price: 30,
                        },
                    ],
                    styles: [
                        {title: 'Patacones', price: 0},
                        {title: 'Yuca al mojo', price: 0},
                        {title: 'Yuca frita', price: 0},
                        {title: 'Papas fritas', price: 0},
                        {title: 'Arroz', price: 0},
                    ],
                    sides: [],
                    pic: 'picada_mixta.jpg',
                    price: 0,
                    type: 'main',
                },

                {
                    title: 'Langosta',
                    subtitle: 'Lobster',
                    desc: 'Con ensalada y acompañamiento de su eleccion.',
                    options: [
                        {title: 'Patacones', price: 0},
                        {title: 'Yuca al mojo', price: 0},
                        {title: 'Yuca frita', price: 0},
                        {title: 'Papas fritas', price: 0},
                        {title: 'Arroz', price: 0},
                    ],
                    styles: [],
                    sides: [],
                    pic: 'langosta_al_ajillo.jpg',
                    price: 35,
                    type: 'main',
                },
                {
                    title: 'Langostinos',
                    subtitle: 'Jumbo shrimps',
                    desc: 'Con ensalada y acompañamiento de su eleccion.',
                    options: [
                        {title: 'Patacones', price: 0},
                        {title: 'Yuca al mojo', price: 0},
                        {title: 'Yuca frita', price: 0},
                        {title: 'Papas fritas', price: 0},
                        {title: 'Arroz', price: 0},
                    ],
                    styles: [],
                    sides: [],
                    pic: 'langostinos_al_ajillo.jpg',
                    price: 12,
                    type: 'main',
                },
                {
                    title: 'Camarones al ajillo',
                    subtitle: 'Shrimps in garlic sauce',
                    desc: 'Con ensalada y acompañamiento de su eleccion.',
                    options: [
                        {title: 'Patacones', price: 0},
                        {title: 'Yuca al mojo', price: 0},
                        {title: 'Yuca frita', price: 0},
                        {title: 'Papas fritas', price: 0},
                        {title: 'Arroz', price: 0},
                    ],
                    styles: [],
                    sides: [],
                    pic: 'camarones_al_ajillo.jpg',
                    price: 10,
                    type: 'main',
                },
                {
                    title: 'Camarones apanados',
                    subtitle: 'Breaded shrimps',
                    desc: 'Con ensalada y acompañamiento de su eleccion.',
                    options: [
                        {title: 'Patacones', price: 0},
                        {title: 'Yuca al mojo', price: 0},
                        {title: 'Yuca frita', price: 0},
                        {title: 'Papas fritas', price: 0},
                        {title: 'Arroz', price: 0},
                    ],
                    styles: [],
                    sides: [],
                    pic: 'camarones_apanados.jpeg',
                    price: 10,
                    type: 'main',
                },
                {
                    title: 'Mixto de mariscos',
                    subtitle: 'Seafood mix',
                    desc: 'Con ensalada y acompañamiento de su eleccion.',
                    options: [
                        {title: 'Patacones', price: 0},
                        {title: 'Yuca al mojo', price: 0},
                        {title: 'Yuca frita', price: 0},
                        {title: 'Papas fritas', price: 0},
                        {title: 'Arroz', price: 0},
                    ],
                    styles: [],
                    sides: [],
                    pic: 'mixto_de_mariscos.jpg',
                    price: 10,
                    type: 'main',
                },
                {
                    title: 'Patacones rellenos mixtos',
                    subtitle: 'Fried plantain cups filled with seafood',
                    desc: 'Con ensalada y acompañamiento de su eleccion.',
                    options: [
                        {title: 'Patacones', price: 0},
                        {title: 'Yuca al mojo', price: 0},
                        {title: 'Yuca frita', price: 0},
                        {title: 'Papas fritas', price: 0},
                        {title: 'Arroz', price: 0},
                    ],
                    styles: [],
                    sides: [],
                    pic: 'patacones_rellenos_de_mixtos.jpg',
                    price: 10,
                    type: 'main',
                },
                {
                    title: 'Patacones rellenos de camarones',
                    subtitle: 'Fried plantain cups filled with shrimps',
                    desc: 'Con ensalada y acompañamiento de su eleccion.',
                    options: [
                        {title: 'Patacones', price: 0},
                        {title: 'Yuca al mojo', price: 0},
                        {title: 'Yuca frita', price: 0},
                        {title: 'Papas fritas', price: 0},
                        {title: 'Arroz', price: 0},
                    ],
                    styles: [],
                    sides: [],
                    pic: 'patacones_rellenos_de_camaraones.jpg',
                    price: 12,
                    type: 'main',
                },
                {
                    title: 'Tiritas de pollo frito',
                    subtitle: 'Chicken tenders',
                    desc: 'Con ensalada y acompañamiento de su eleccion.',
                    options: [
                        {title: 'Patacones', price: 0},
                        {title: 'Yuca al mojo', price: 0},
                        {title: 'Yuca frita', price: 0},
                        {title: 'Papas fritas', price: 0},
                        {title: 'Arroz', price: 0},
                    ],
                    styles: [],
                    sides: [],
                    pic: 'tender_de_pollo.jpg',
                    price: 8,
                    type: 'main',
                },
                {
                    title: 'Ceviche de pescado',
                    subtitle: 'Fish',
                    desc: '',
                    options: [{title: 'Regular', price: 0}],
                    styles: [],
                    sides: [],
                    pic: 'ceviche_de_corvina.jpg',
                    price: 2,
                    type: 'ceviche',
                },
                {
                    title: 'Ceviche de camaron',
                    subtitle: 'Shrimp',
                    desc: '',
                    options: [{title: 'Regular', price: 0}],
                    styles: [],
                    sides: [],
                    pic: 'coctail_de_camaron.jpg',
                    price: 3.5,
                    type: 'ceviche',
                },
                {
                    title: 'Ceviche de pulpo',
                    subtitle: 'Octopus',
                    desc: '',
                    options: [{title: 'Regular', price: 0}],
                    styles: [],
                    sides: [],
                    pic: 'ceviche_de_pulpo.jpg',
                    price: 3,
                    type: 'ceviche',
                },
                {
                    title: 'Ceviche de combinacion',
                    subtitle: 'Combination',
                    desc: '',
                    options: [{title: 'Regular', price: 0}],
                    styles: [],
                    sides: [],
                    pic: 'ceviche_de_combinacion.jpg',
                    price: 4,
                    type: 'ceviche',
                },
                {
                    title: 'Ceviche de concha negra',
                    subtitle: 'Black shell',
                    desc: '',
                    options: [{title: 'Regular', price: 0}],
                    styles: [],
                    sides: [],
                    pic: 'ceviche_de_concha_negra.jpg',
                    price: 4.5,
                    type: 'ceviche',
                },
                {
                    title: 'Cocktail de combinacion',
                    subtitle: 'Combination cocktail',
                    desc: '',
                    options: [{title: 'Regular', price: 0}],
                    styles: [],
                    sides: [],
                    pic: 'coctail_de_combinacion.jpg',
                    price: 4.25,
                    type: 'ceviche',
                },
                {
                    title: 'Cocktail de camaron',
                    subtitle: 'Shrimp Cocktail',
                    desc: '',
                    options: [{title: 'Regular', price: 0}],
                    styles: [],
                    sides: [],
                    pic: 'coctail_de_camaron.jpg',
                    price: 4,
                    type: 'ceviche',
                },
                {
                    title: 'Cerveza nacional',
                    subtitle: 'National beer',
                    desc: '',
                    options: [
                        {title: 'Atlas', price: 0},
                        {title: 'Balboa', price: 0},
                        {title: 'Panama', price: 0},
                        {title: 'Soberana', price: 0},
                    ],
                    styles: [],
                    sides: [],
                    pic: '',
                    price: 1.25,
                    type: 'drink',
                },
                {
                    title: 'Cerveza internacional',
                    subtitle: 'International beer',
                    desc: '',
                    options: [
                        {title: 'Miller Lite', price: 0},
                        {title: 'Coors Light', price: 0},
                    ],
                    styles: [],
                    sides: [],
                    pic: '',
                    price: 2,
                    type: 'drink',
                },
                {
                    title: 'Corona',
                    subtitle: '',
                    desc: '',
                    options: [{title: 'Botella', price: 0}],
                    styles: [],
                    sides: [],
                    pic: '',
                    price: 2.5,
                    type: 'drink',
                },
                {
                    title: 'Smirnoff Ice',
                    subtitle: '',
                    desc: '',
                    options: [{title: 'Botella', price: 0}],
                    styles: [],
                    sides: [],
                    pic: '',
                    price: 2.5,
                    type: 'drink',
                },
                {
                    title: 'Gatorade',
                    subtitle: '',
                    desc: '',
                    options: [{title: 'Botella', price: 0}],
                    styles: [],
                    sides: [],
                    pic: '',
                    price: 2,
                    type: 'drink',
                },
                {
                    title: 'Soda',
                    subtitle: 'Soft drinks',
                    desc: '',
                    options: [
                        {title: 'Coca Cola', price: 0},
                        {title: 'Squirt', price: 0},
                        {title: 'Ginger Ale', price: 0},
                    ],
                    styles: [],
                    sides: [],
                    pic: '',
                    price: 1,
                    type: 'drink',
                },
                {
                    title: 'Agua',
                    subtitle: 'Bottled water',
                    desc: '',
                    options: [{title: 'Botella', price: 0}],
                    styles: [],
                    sides: [],
                    pic: '',
                    price: 1,
                    type: 'drink',
                },
                {
                    title: 'Te frio',
                    subtitle: 'Iced tea',
                    desc: '',
                    options: [{title: 'Regular', price: 0}],
                    styles: [],
                    sides: [],
                    pic: '',
                    price: 2,
                    type: 'drink',
                },
                {
                    title: 'Limonada',
                    subtitle: 'Lemonade',
                    desc: '',
                    options: [{title: 'Regular', price: 0}],
                    styles: [],
                    sides: [],
                    pic: '',
                    price: 2,
                    type: 'drink',
                },
                {
                    title: 'Acompañamientos adicionales',
                    subtitle: 'Sides',
                    desc: '',
                    options: [
                        {title: 'Patacones', price: 0},
                        {title: 'Yuca al mojo', price: 0},
                        {title: 'Yuca frita', price: 0},
                        {title: 'Papas fritas', price: 0},
                        {title: 'Arroz', price: 0},
                    ],
                    styles: [],
                    sides: [],
                    pic: '',
                    price: 2,
                    type: 'side',
                },
            ],
        }
    },
    methods: {
        filterMenu(menu) {
            let type = ''
            if (this.selectedCategory === 'Todo / All') {
                type = 'all'
                return this.menu
            }
            if (this.selectedCategory === null) {
                return this.menu
            }
            if (this.selectedCategory === 'Entradas / Starters')
                type = 'starter'
            if (this.selectedCategory === 'Platillos / Main dishes')
                type = 'main'
            if (this.selectedCategory === 'Ceviches') type = 'ceviche'
            if (this.selectedCategory === 'Bebidas / Drinks') type = 'drink'
            if (this.selectedCategory === 'Acompañantes / Sides') type = 'side'
            return menu.filter(m => {
                if (m.type === type) return m
            })
        },
        addItemToCart() {
            if (!this.checkIfDuplicate()) {
                this.selectedItem.amount = 1
                this.cart.push(this.selectedItem)
                this.optionsDialog = false
                this.successDialog = true
                this.calculateTotal()
            } else {
                this.cart.forEach(c => {
                    if (
                        c.type === this.selectedItem.type &&
                        c.title === this.selectedItem.title &&
                        c.options.title === this.selectedItem.options.title &&
                        c.styles.title === this.selectedItem.styles.title &&
                        c.sides.title === this.selectedItem.sides.title
                    ) {
                        c.amount++
                    }
                })
                this.optionsDialog = false
                this.successDialog = true
                this.calculateTotal()
            }
        },
        handleDialogs(section, item) {
            //option, style, side
            if (section === 'option') {
                this.selectedItem.options = item
                this.optionsDialog = false
                if (this.menu[this.selectedItemIndex].styles.length > 0) {
                    this.stylesDialog = true
                } else {
                    this.addItemToCart()
                }
            }
            if (section === 'style') {
                this.selectedItem.styles = item
                this.stylesDialog = false
                if (this.menu[this.selectedItemIndex].sides.length > 0) {
                    this.sideDialog = true
                } else {
                    this.addItemToCart()
                }
            }
            if (section === 'side') {
                this.sideDialog = false
                this.selectedItem.sides = item
                this.addItemToCart()
            }
        },
        selectItem(item) {
            let itemInMenu = this.menu.filter((m, index) => {
                if (m.title === item.title) {
                    this.selectedItemIndex = index
                    return m
                }
            })
            this.selectedItem = JSON.parse(
                JSON.stringify(this.menu[this.selectedItemIndex])
            )
            this.optionsDialog = true
        },
        checkIfDuplicate() {
            let isDuplicate = false
            if (this.cart.length <= 0) {
                isDuplicate = false
            }

            this.cart.forEach(c => {
                if (
                    c.type === this.selectedItem.type &&
                    c.title === this.selectedItem.title &&
                    c.options.title === this.selectedItem.options.title &&
                    c.styles.title === this.selectedItem.styles.title
                ) {
                    isDuplicate = true
                }
            })

            return isDuplicate
        },
        removeItemFromCart(i) {
            this.cart.splice(i, 1)
        },
        calculateTotal() {
            let total = 0
            this.cart.forEach(c => {
                if (c.price) total += c.price * c.amount
                if (c.options.price) total += c.options.price * c.amount
                if (c.styles.price) total += c.styles.price * c.amount
                if (c.sides.price) total += c.sides.price * c.amount
            })
            this.total = total
        },
        generateMessage() {
            let message =
                'Buenas me gustaria realizar un pedido de:%0D%0A%0D%0A'
            for (let item of this.cart) {
                message += `- (${item.amount}) ${item.title} - ${item.options.title}`
                if (item.styles.title != undefined) {
                    message += `- ${item.styles.title}`
                }
                if (item.sides.title != undefined) {
                    message += `- ${item.sides.title}`
                }
                message += `%0D%0A`
            }
            message += `%0D%0ANo. de pedido: ${this.orderNo}%0D%0ANombre: ${this.name}`
            if (this.selectedPickupMethod == 'Delivery') {
                message += `%0D%0AUbicacion: ${this.getLocationForMessage()}%0D%0ADireccion: ${
                    this.address
                }`
            }
            message += `%0D%0AMetodo de entrega: ${
                this.selectedPickupMethod
            }%0D%0AMetodo de pago: ${this.selectedPaymentMethod}%0D%0ALocal: ${
                this.selectedPremises
            }%0D%0ATotal: $ ${this.total.toFixed(2)}`
            message = message.replace(/\+/g, '%2B')
            message = message.replace(/&/g, '%26')
            message = message.replace(/#/g, '%23')
            return message
        },
        async sendEmail() {
            let message = ''
            for (let item of this.cart) {
                if (item.type == 'starter')
                    message += `(${item.amount}) ${item.title}<br>`
                if (item.type == 'main')
                    message += `(${item.amount}) ${item.title} ${
                        item.styles.title ? '- ' + item.styles.title + ' ' : ''
                    } - ${item.options.title}<br>`
                if (item.type == 'ceviche')
                    message += `(${item.amount}) ${item.title}<br>`
                if (item.type == 'side')
                    message += `(${item.amount}) Extra - ${item.title} - ${item.options.title}<br>`
                if (item.type == 'drink')
                    message += `(${item.amount}) ${item.title} - ${item.options.title}<br>`
            }
            let data = {
                id: this.orderNo,
                pedido: message,
                nombre: this.name,
                status: 'orden creada',
                total: this.total,
                metodo_de_pago: this.selectedPaymentMethod,
                metodo_de_entrega: this.selectedPickupMethod,
            }
            if (data.metodo_de_entrega === 'Delivery') {
                data.direcion_1 = this.getLocationForMessage()
                data.direcion_2 = this.address
            }
            await emailjs.send(
                'gmail',
                'template_n11yl4q',
                data,
                'user_l9KYZVj8DNvwXi3kegar5'
            )
        },
        async sendToGoogleDriveSheet() {
            let message = ''
            for (let item of this.cart) {
                message += `- (${item.amount}) ${item.title} - ${item.options.title}`
                if (item.styles.title != undefined) {
                    message += `- ${item.styles.title}`
                }
                if (item.sides.title != undefined) {
                    message += `- ${item.sides.title}`
                }
                message += `\n`
            }
            let data = {
                id: this.orderNo,
                pedido: message,
                nombre: this.name,
                status: 'orden creada',
                total: this.total,
                local: this.selectedPremises,
                metodo_de_pago: this.selectedPaymentMethod,
                metodo_de_entrega: this.selectedPickupMethod,
            }
            if (data.metodo_de_entrega === 'Delivery') {
                data.direcion_1 = this.getLocationForMessage()
                data.direcion_2 = this.address
            }
            var url =
                'https://script.google.com/macros/s/AKfycbzPCB7GpZlqm0iKBy8mDPpa12_QFmcTukrsPlaINRFSYjWGvfD9/exec'
            var xhr = new XMLHttpRequest()
            xhr.open('POST', url)
            // xhr.withCredentials = true;
            xhr.setRequestHeader(
                'Content-Type',
                'application/x-www-form-urlencoded'
            )
            // url encode form data for sending as post data
            var encoded = Object.keys(data)
                .map(function (k) {
                    return (
                        encodeURIComponent(k) +
                        '=' +
                        encodeURIComponent(data[k])
                    )
                })
                .join('&')
            await xhr.send(encoded)
        },
        getLocationForMessage() {
            if (this.location.length === 0) {
                if (
                    parseFloat(this.center.lat) ===
                        parseFloat(this.defaultLat) &&
                    parseFloat(this.center.lng) === parseFloat(this.defaultLng)
                ) {
                    return `>> Pedir Ubicacion !!`
                } else {
                    if (this.center.lat < 0)
                        this.center.lng = `+${this.center.lng}` //Google Maps
                    if (this.center.lng < 0)
                        this.center.lng = `+${this.center.lng}` //Google Maps
                    return `https://www.google.com/maps?q=${this.center.lat},${this.center.lng}`
                    // return `https://waze.com/ul?ll=${this.center.lat},${this.center.lng}&z=10`
                }
            } else {
                let lat = parseFloat(this.location.lat)
                let lng = parseFloat(this.location.lng)
                if (lat === NaN || lng === NaN) return `>> Pedir Ubicacion !!`
                if (lat < 0) lat = `+${lat}` //Google Maps
                if (lng < 0) lng = `+${lng}` //Google Maps
                return `https://www.google.com/maps?q=${lat},${lng}`
                // return `https://waze.com/ul?ll=${lat},${lng}&z=10`
            }
        },
        setMarkerPosition(event) {
            this.location = event
        },
        geolocate() {
            navigator.geolocation.getCurrentPosition(
                position => {
                    this.center = {
                        lat: parseFloat(position.coords.latitude),
                        lng: parseFloat(position.coords.longitude),
                    }
                    this.markers.push({position: this.center})
                },
                error => {
                    this.center = {
                        lat: parseFloat(this.defaultLat),
                        lng: parseFloat(this.defaultLng),
                    }
                    this.markers.push({position: this.center})
                }
            )
        },
        async sendChat() {
            if (this.name == '') {
                alert('Debes ingresar tu nombre para enviar el pedido.')
                return
            }
            if (this.selectedPremises == '') {
                alert('Debes el local de servicio.')
                return
            }
            if (this.selectedPickupMethod == '') {
                alert('Debes seleccionar un metodo de entrega.')
                return
            }
            if (this.address == '' && this.selectedPickupMethod == 'Delivery') {
                alert(
                    'Debes ingresar tu direccion completa para la entrega de tu pedido.'
                )
                return
            }
            if (this.selectedPaymentMethod == null) {
                alert('Debes seleccionar un metodo de pago.')
                return
            } else {
                this.orderNo = Math.floor(100000 + Math.random() * 900000)
                this.$analytics.logEvent('wp-ceciliapescao', {
                    content_action: 'Orden Completada',
                })
                this.displayLoading = true
                await this.sendEmail()
                let whatsappMessage = await this.generateMessage()
                this.cart = []
                this.seamless = false
                window.location.href = `https://wa.me/507${this.whatsappNumber}?text=${whatsappMessage}`
                this.displayLoading = false
            }
        },
    },
    watch: {
        cart() {
            this.calculateTotal()
            if (this.cart.length > 0) {
                this.seamless = true
                this.$store.commit('SET_DISPLAYFOOTER', true)
            } else {
                this.seamless = false
                this.$store.commit('SET_DISPLAYFOOTER', false)
            }
        },
        // selectedPickupMethod() {
        //     if (this.selectedPickupMethod == 'Delivery')
        //         this.locationDialog = true
        // },
    },
    components: {
        GoogleMaps,
    },
    mounted() {
        if (this.$hj) {
            this.$hj('vpv', 'funnel-step-one')
        }
        this.$store.commit('SET_DISPLAYFOOTER', false)
        let path = this.$route.params.path
        this.$analytics.logEvent('wp-cerotranque', {
            path,
        })
        this.geolocate()
    },
    components: {
        GoogleMaps,
    },
}
